import { Component, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { EditorChangeContent, EditorChangeSelection, Focus } from 'ngx-quill';
import {
  faInfo,
  faFileExport,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faSkiing,
  faSitemap,
  faSearch,
  faLightbulb,
  faBoxOpen,
  faCircle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { SocketService } from '../shared/services/socket.service';
import { faJira } from '@fortawesome/free-brands-svg-icons';
import { JiraBugsListComponent } from '../jira-bugs-list/jira-bugs-list.component';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { LandscaperComponent } from '../landscaper/landscaper.component';
import { MainComponent } from '../main/main.component';
import { EntityTestComponent } from '../entity-test/entity-test.component';
// import { features } from 'node:process';
declare var $: any;

@Component({
  selector: 'app-deep-dive',
  templateUrl: './deep-dive.component.html',
  styleUrls: ['./deep-dive.component.scss'],
})
export class DeepDiveComponent implements OnInit {
  faCircle = faCircle;
  faSkiing = faSkiing;
  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faLightbulb = faLightbulb;
  faSitemap = faSitemap;
  faFileExport = faFileExport;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faPlus = faPlus;
  faBoxOpen = faBoxOpen;
  faJira = faJira;
  clickEventsubscriptionSocket: Subscription;
  smartChecklist: boolean = true;
  quillEditorContent: any = '';
  selectedEntityNotes: any = {};
  editorContentText: any = '';
  editorContent: any = '';
  selectedString: any = '';
  newPersona: any;
  errorMessage: any;
  duplicateEntity: any;
  mappedAttributes: any;
  syncModelDataObject: any;


  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private reloadToolService: ReloadToolService,
    public mainComponent: MainComponent,
    private Config: Config,
    private appService: AppService,
    public jiraBugsListComponent: JiraBugsListComponent,
    // public EntityTestComponent: EntityTestComponent,
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
    this.clickEventsubscription = this._sharedService
      .getActiveData()
      .subscribe((data) => {
        this.reloadModelSyncActiveData(data);
      });

    this.clickEventsubscription = this._sharedService
      .getClickEvent()
      .subscribe((eut) => {
        this.activate(eut);
      });
  }
  model: any;
  planner: any;
  index = 0;
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  eutTypes = ['TF', 'UR', 'BF', 'XX'];
  selectedModule: any = {};
  selectedEUT = 'UR';
  entityData: any = {};
  currentTab: any = 'specs';
  selectedTestType: any = { "symbol": '', "desc": '' };
  selectedEntity = {
    bDescription: '',
    bc: '',
    ac: '',
    outcomes: '',
    pIssues: '',
    eID: '',
  };
  entityBC: any;
  entityAC: any;
  entityOC: any;
  entityPI: any;
  entityDesc: any;
  persona: any = [];
  attribute: any = [];
  interaction: any = [];
  entityName = '';
  modelData: any;
  jiraProjectData: any;
  config: any;
  mapText = '';
  searchText = '';
  clickEventsubscription: Subscription;
  selectedEntityIDDetails: any;
  jiraInterfaceDisabled = false;

  ngOnInit(): void {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });

    setTimeout(() => {
      this.getVideoURL('Dd');
      this.jiraProjectData = this._sharedService.jiraProjectData;
      // console.log('this.jiraProjectData', this.jiraProjectData);
      if (this.jiraProjectData.length === 0) {
        // this.jiraInterfaceDisabled = true;
      }
    }, 2000);
    this.config = this.Config;
    this.modelData = this._sharedService.loadedProjectData.model;
    this.selectedModule = this.modelData.modules[0];
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    this.reloadToolService.triggerSmartChecklist('');
    window.localStorage.removeItem("entityTestName");
  }

  reloadModelSyncActiveData(syncData: any) {
    if (syncData.type == "SPECS") {
      if (syncData.data.eID == this.selectedEntity.eID) {
        this.constructMapping();
      } else {
      }
    }
  }
  openChatGPTassist() {
    this.mainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", "ET-DD");
    // setTimeout(() => {
    //   if (this.choosenEUT) {
    //     this.loadEntityDetails(this.choosenEUT);
    //   }
    // }, 500);
  }
  addPersona() {
    let newPersona = this.newPersona;
    if (newPersona) {
      for (var i = 0; i < this.modelData.persona.length; i++) {
        if (
          this.modelData.persona[i].pName.toLowerCase() ==
          newPersona.toLowerCase()
        ) {
          this.duplicateEntity = newPersona;
          this.errorMessage = "Already exists!";
          $('#duplicateErrorMessagePopupModel').modal('show');
          this.newPersona;
          return;
        }
      }
      var newPersonaObj = {
        pName: newPersona,
        pType: this.uniqueID('P'),
      };
      this.modelData.persona.unshift(newPersonaObj);
      this.syncModelDataObject = {
        "type": "PERSONA",
        "operation": "CREATE",
        "data": newPersonaObj
      }
      this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      this.clearAddPersona();
    } else {
      this.errorMessage = "Persona can't be empty.";
      $('#duplicateErrorMessagePopupModel').modal('show');
      this.clearAddPersona();
    }

  }
  clearAddPersona() {
    this.newPersona = '';
  }
  //generation of unique id for persona
  uniqueID(type: any) {
    var model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      type +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  changeTab(tabName: any) {
    this.currentTab = tabName;
    // console.log(this.currentTab);
  }
  // onReloadInit(EUTdetails: any, listOfEUTs: any) {

  //   if (this.selectedEntity) {
  //     this.selectedEntityfound = listOfEUTs.find(eut => eut.eID == this.selectedEntity.eID);
  //     // console.log('selectedEntityfound', this.selectedEntityfound);
  //     if (this.selectedEntityfound) {
  //       // // console.log('dd if exist');
  //       this.loadEntityDetails(this.selectedEntityfound);
  //     } else {
  //       // // console.log('dd else exist');
  //       this.selectedEntity = {};
  //       this.entityName = "";
  //       this.mapText = "";
  //       this.selectedEntityIDDetails = {};
  //     }
  //   } else {
  //     this.selectedEntity = {};
  //     this.entityName = "";
  //     this.mapText = "";
  //     this.selectedEntityIDDetails = {};
  //   }
  // }
  // passData(eut: any){
  //   this.entityData
  // }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  activate(eut: any) {
    // console.log("eut",eut);
    if (eut.toolType == 'dd') {
      this.selectedModule = this.modelData.modules.find(
        (mod: any) => mod.mID == eut.mID
      );
      // console.log('eutDeeepdive', eut);
      this.loadEntityDetails(eut);
      this.index = this.eutTypes.findIndex((type) => type == eut.eType);
    }
  }

  //function to get scenario count by eutID
  getScenarioCountByeutID(eut: any) {
    var count = 0;
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (this.modelData.scenarios[i].eID == eut.eID) {
        count++;
      }
    }
    return count;
  }

  //function to get modulename by moduleID
  getModuleName(eut: any) {
    var foundModule: any = this.modelData.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  //changing the entity type by toggling the span button
  //reset the entity name and details populated in the form
  changeEntity() {
    this.index = (this.index + 1) % this.eutTypes.length;
    this.selectedEntity = {
      bDescription: '',
      bc: '',
      ac: '',
      outcomes: '',
      pIssues: '',
      eID: ''
    };
    this.entityName = '';
    this.mapText = '';
    this.entityBC = '';
    this.entityOC = '';
    this.entityPI = '';
    this.entityAC = '';
    this.entityDesc = '';
  }
  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  selectModule(test: any) {
    this.selectedModule = test;
    this.index = this.eutTypes.findIndex((type) => type == test);
    this.selectedEntity = {
      bDescription: '',
      bc: '',
      ac: '',
      outcomes: '',
      pIssues: '',
      eID: ''
    };
    this.quillEditorContent = '';
    this.entityName = '';
    this.mapText = '';
    this.entityBC = '';
    this.entityOC = '';
    this.entityPI = '';
    this.entityAC = '';
    this.entityDesc = '';
    window.localStorage.removeItem('deepdiveSelected');
  }

  //handler to get the required details based on the selected entity
  loadEntityDetails(eutChosen: any) {
    // console.log('eutChoosen', eutChosen);
    this.mapText = '';
    this.selectedEntityIDDetails = this.modelData.listOfEUTs.find(
      (eut: any) => eut.eID == eutChosen.eID
    );
    if (this.selectedEntityIDDetails) {
      this.entityName = this.selectedEntityIDDetails.eName;
    }

    this.selectedEntity = this.modelData.EUTdetails.find(
      (eut: any) => eut.eID == eutChosen.eID
    );
    if (!this.selectedEntity) {
      this.addEutDetails(eutChosen);
      this.selectedEntity = this.modelData.EUTdetails.find(
        (eut: any) => eut.eID == eutChosen.eID
      );
    } else {
      this.getMaps();
    }

    this.selectedEntityNotes = this.modelData.myNotes.find(
      (eut: any) => eut.eID == eutChosen.eID
    );
    window.localStorage.setItem("entityTestName", this.entityName);
    window.localStorage.setItem('entityTestID', eutChosen.eID);
    if (this.selectedEntityNotes) {
      window.localStorage.setItem("entityTestDescription", this.selectedEntityNotes.notes);
    }
    if (this.selectedEntityNotes) {
      this.quillEditorContent = this.selectedEntityNotes.notes;
    } else {
      this.quillEditorContent = '';
    }
    if (this.selectedEntity) {
      this.entityBC = this.selectedEntity.bc;
      this.entityAC = this.selectedEntity.ac;
      this.entityOC = this.selectedEntity.outcomes;
      this.entityPI = this.selectedEntity.pIssues;
      this.entityDesc = this.selectedEntity.bDescription;
    }
    // console.log('eutDetails', this.modelData.EUTdetails);
    // console.log('map', this.selectedEntity);
    this.getMaps();
    // eutChosen['mapText'] = this.mapText;
    window.localStorage.setItem('deepdiveSelected', JSON.stringify(eutChosen));
  }

  updateEntityDetails(detail: any) {
    // console.log('updateEntityDetails', detail);
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        // console.log("match");
        this.modelData.EUTdetails[i]['bc'] = this.selectedEntity.bc;
        this.modelData.EUTdetails[i]['ac'] = this.selectedEntity.ac;
        this.modelData.EUTdetails[i]['outcomes'] = this.selectedEntity.outcomes;
        this.modelData.EUTdetails[i]['pIssues'] = this.selectedEntity.pIssues;
        this.modelData.EUTdetails[i]['bDescription'] = this.selectedEntity.bDescription;
        this.syncModelDataObject = {
          "type": "SPECS",
          "operation": "UPDATE",
          "detail": detail,
          "data": this.modelData.EUTdetails[i]
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
        console.log("this.syncModelDataObject",this.syncModelDataObject);
      }
    }

  }
  editorChanged(event: EditorChangeContent | EditorChangeSelection) {
    this.editorContent = event['editor']['root']['innerHTML'];
    this.editorContentText = event['editor']['root']['innerText'];
    if (event['event'] == 'selection-change') {
      var range: any = event['range'];
      this.selectedString = '';
      var text = event.editor.getText(range['index'], range['length']);
      this.selectedString = text.split('\n');
      this.selectedString = this.selectedString.filter((item: any) => item);
    } else {

    }
  }
  blur(event: Focus) {
    var foundNotes = false;
    let notesObject;
    if (this.selectedEntity.eID) {
      if (this.modelData.myNotes.length > 0) {
        for (var i = 0; i < this.modelData.myNotes.length; i++) {
          if (this.modelData.myNotes[i].eID == this.selectedEntity.eID) {
            this.modelData.myNotes[i]['notes'] = this.editorContent;
            foundNotes = true;
            this.syncModelDataObject = {
              "type": "NOTES",
              "operation": "UPDATE",
              "data": this.selectedEntity,
              "notes": this.editorContent
            }
            this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
          }
        }
        if (foundNotes == false) {
          notesObject = {
            "eID": this.selectedEntity.eID,
            "notes": this.editorContent
          }
        }
      } else {
        notesObject = {
          "eID": this.selectedEntity.eID,
          "notes": this.editorContent
        }
      }
      if (notesObject != null) {
        this.modelData.myNotes.push(notesObject);
        this.syncModelDataObject = {
          "type": "NOTES",
          "operation": "CREATE",
          "data": notesObject
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
      // console.log(this.modelData.myNotes);
    }
  }
  addEutDetails(eut: any) {
    // console.log("EUTdetails", eut);
    // return;
    this.modelData.EUTdetails.push({
      eID: eut.eID,
      bc: '',
      ac: '',
      outcomes: '',
      bDescription: '',
      pIssues: '',
      notes: this.config.entityDefaultNotes
    });
   
    this.syncModelDataObject = {
      "type": "SPECS",
      "operation": "ADD",
      "data": eut
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }
  //handler that access the model functions to return the related mapping details based on chosen eutID
  getMaps() {
    if (this.selectedEntity) {
      this.persona = this.getPersonaForAnEut(this.selectedEntity);
      this.attribute = this.getScopeForAnEut(this.selectedEntity);
      this.interaction = this.getInteractionMappingForAnEut(
        this.selectedEntity
      );
      // console.log('iMap', this.interaction);
      this.constructMapping();
    }
  }
  getPersonaForAnEut(eut: any) {
    var mappedPersonaForEut = this.modelData.personaMap.filter(
      (map: any) => map.eID == eut.eID
    );
    return mappedPersonaForEut;
  }
  getScopeForAnEut(eut: any) {
    var mappedScopeForEut = this.modelData.scopeMap.filter(
      (map: any) => map.eID == eut.eID
    );
    return mappedScopeForEut;
  }
  getInteractionMappingForAnEut(eut: any) {
    var mappedInteractionForEut = this.modelData.interactionMap.filter(
      (map: any) => map.eut1 == eut.eID
    );
    return mappedInteractionForEut;
  }
  //Check whether the persona in list is present in the persona mapping for the choosen eut
  isChecked(persona: any) {
    if (this.persona.length > 0) {
      var p = this.persona.findIndex((p: any) => p.pType == persona);
      return p > -1 ? true : false;
    } else {
      return false;
    }
  }

  //Check whether the attribute in list is present in the scope map for the choosen eut
  isCheckedAtt(attribute: any) {
    if (this.attribute.length > 0) {
      var a = this.attribute.findIndex((a: any) => a.aType == attribute.symbol);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }

  //Check whether the eut in list is present in the interaction mapping for the choosen eut
  isCheckedInter(eut: any) {
    if (this.interaction.length > 0) {
      var a = this.interaction.findIndex((a: any) => a.eut2 == eut.eID);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }

  //checks the current value of the check box for persona drop down
  //if true -> adds to the persona model
  //if false -> removes from the persona model
  mapEutToPerson(persona: any, isChecked: any) {
    isChecked
      ? this.addPer(persona, this.selectedEntity)
      : this.deletePer(persona, this.selectedEntity);
    this.getMaps();
    this.constructMapping();
  }
  addPer(persona: any, eut: any) {
    this.modelData.personaMap.push({ pType: persona, eID: eut.eID });
    this.syncModelDataObject = {
      "type": "PMAP",
      "operation": "CREATE",
      "data": { pType: persona, eID: eut.eID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log('per', this.modelData.personaMap);
  }

  deletePer(persona: any, eut: any) {
    var index = this.modelData.personaMap.findIndex(
      (map: any) => map.eID == eut.eID && map.pType == persona
    );
    if (index > -1) {
      this.modelData.personaMap.splice(index, 1);
    }
    this.syncModelDataObject = {
      "type": "PMAP",
      "operation": "DELETE",
      "data": { pType: persona, eID: eut.eID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }
  //checks the current value of the check box for attributes drop down
  //if true -> adds to the scope model
  //if false -> removes from the scope model
  mapEutToAtt(att: any, isChecked: any) {
    // console.log('checked', isChecked);
    isChecked
      ? this.addAttr(att, this.selectedEntity)
      : this.deleteAttr(att, this.selectedEntity);
    this.getMaps();
    this.constructMapping();
  }
  addAttr(att: any, eut: any) {
    this.modelData.scopeMap.push({
      aType: att,
      eID: eut.eID,
    });
    this.syncModelDataObject = {
      "type": "SMAP",
      "operation": "CREATE",
      "data": {
        aType: att,
        eID: eut.eID,
      }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // var eut = this.modelData.listOfEUTs.find((eut: any) => eut.eID == eut.eID);
    var attribute = this.Config.listOfAttributesUpdated.find(
      (attr: any) => attr.symbol == att
    );

    if (eut) {
      // console.log("eut",eut);
      var Task = this.modelData.tasks.find((task: any) => task.entity_Id == eut.eID);
      // console.log("Task",Task);
      this.generateTaskFromScope(Task, attribute);
      for (var i = 0; i < this.modelData.tasks.length; i++) {
        if (this.modelData.tasks[i].entity_Id == eut.eID) {
          if (this.modelData.tasks[i].toolType == 'pm' || this.modelData.tasks[i].toolType == 'im' || this.modelData.tasks[i].toolType == 'sc' || this.modelData.tasks[i].toolType == 'dd') {
            this.modelData.tasks[i]['attribute'] = attribute;
          }
        }
      }
    }
    this.checkAndUpdateTestTypeDescByEUT(att);
  }

  checkAndUpdateTestTypeDescByEUT(att: any) {
    // console.log("this.selectedEntity", this.selectedEntity);
    // console.log("this.att", att);

    this.selectedTestType = { "symbol": att, "desc": '' };
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        if (this.modelData.EUTdetails[i].testTypes) {
          var Testtypeexists = this.modelData.EUTdetails[i].testTypes.find(
            (test: any) => test.symbol == att
          );
          if (Testtypeexists) {
            this.selectedTestType = Testtypeexists;
          } else {
            this.modelData.EUTdetails[i].testTypes.push(this.selectedTestType);
          }
        } else {
          this.modelData.EUTdetails[i]['testTypes'] = [this.selectedTestType];
        }
      }
    }
    this.syncModelDataObject = {
      "type": "SPECS",
      "operation": "TESTTYPEDescAdd",
      "data": this.selectedTestType,
      "eut": this.selectedEntity
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("this.modelData.EUTdetails", this.modelData.EUTdetails);
    $('#testTypeDescModal').modal('show');
  }

  updateTestTypeDesc() {
    // console.log(this.selectedTestType);
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        for (var j = 0; j < this.modelData.EUTdetails[i].testTypes.length; j++) {
          if (this.modelData.EUTdetails[i].testTypes[j].symbol == this.selectedTestType.symbol) {
            this.modelData.EUTdetails[i].testTypes[j].desc = this.selectedTestType.desc;
            // return;
          }
        }
        // return;
      }
    };
    this.syncModelDataObject = {
      "type": "SPECS",
      "operation": "TESTTYPEDescUpdate",
      "data": this.selectedTestType,
      "eut": this.selectedEntity
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    setTimeout(() => {
      this.selectedTestType = { "symbol": '', "desc": '' };
    }, 1000);

    $('#testTypeDescModal').modal('hide');
    // console.log("this.modelData.EUTdetails update", this.modelData.EUTdetails);
    this.getMaps();
    this.constructMapping();
  }

  deleteAttr(att: any, eut: any) {
    var index = this.modelData.scopeMap.findIndex(
      (map: any) => map.eID == eut.eID && map.aType == att
    );
    if (index > -1) {
      this.modelData.scopeMap.splice(index, 1);
    }
    this.syncModelDataObject = {
      "type": "SMAP",
      "operation": "DELETE",
      "data": { aType: att, eID: eut.eID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // var eut = this.modelData.listOfEUTs.find((eut: any) => eut.eID == eut.eID);
    // var attribute = this.Config.listOfAttributesUpdated.find(
    //   (attr: any) => attr.symbol == att
    // );
    // if (eut) {
    // var Task = this.modelData.tasks.find((eut: any) => eut.entity_Id == eID);
    // this.generateTaskFromScope(Task, attribute);
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      if (this.modelData.tasks[i].entity_Id == eut.eID && this.modelData.tasks[i].attribute.symbol == att && (this.modelData.tasks[i].toolType == 'de' || this.modelData.tasks[i].toolType == 'ex')) {
        this.modelData.tasks.splice(i, 1);
        i--;
      }
    }
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "SCOPE",
      "data": { aType: att, eID: eut.eID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // }

    this.deleteTestTypeDescByEUT(att);
  }

  deleteTestTypeDescByEUT(att: any) {
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        for (var j = 0; j < this.modelData.EUTdetails[i].testTypes.length; j++) {
          if (this.modelData.EUTdetails[i].testTypes[j].symbol == att) {
            this.modelData.EUTdetails[i].testTypes.splice(j, 1);
          }
        }
      }
    };
    this.syncModelDataObject = {
      "type": "SPECS",
      "operation": "TESTTYPEDescDelete",
      "data": att,
      "eut": this.selectedEntity
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.getMaps();
    this.constructMapping();
  }
  generateTaskFromScope(task: any, attribute: any) {
    // console.log("task", task);
    // console.log("attribute", attribute);
    let taskCreateArray = ['de', 'ex'];
    for (var i = 0; i < taskCreateArray.length; i++) {
      this.generateTaskObjScope(task, attribute, taskCreateArray[i]);
    }
  }

  generateTaskObjScope(task: any, attribute: any, toolType: any) {
    let taskObj: any = {};
    taskObj.task_combine_id = task.task_combine_id;
    taskObj.assignedto = task.assignedto;
    taskObj.assigneduser = task.assigneduser;
    taskObj.attribute = attribute;
    // taskObj.environment = this.model.choosenEntity.environment;
    taskObj.task_desc = this.generateTaskDesc(toolType, task.entity_desc, attribute.name);
    taskObj.activity = { type: 'TN', name: 'Test', shortfrom: 'Test' };
    taskObj.toolType = toolType;
    taskObj.moduleName = task.moduleName;
    taskObj.moduleID = task.moduleID;
    taskObj.entity_Id = task.entity_Id;
    taskObj.entity_desc = task.entity_desc;
    taskObj.entityType = task.entityType;
    // taskObj.primaryentity_Id = this.model.choosenEntity.entity_Id;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.status = 1;
    taskObj.taskId = this.uuidv4();
    // taskObj.impactedUnquieID = impactedUnquieID;
    taskObj.createdOn = new Date();
    // console.log("taskObj", taskObj);
    this.modelData.tasks.push(taskObj);
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "CREATE",
      "data": taskObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("this.modelData.tasks", this.modelData.tasks);
  }


  generateTaskDesc(type: any, eName: any, attribute: any) {
    var description: any;
    if (type == 'pm') {
      description = "do Persona map";
    } else if (type == 'im') {
      description = "do Interaction map";
    } else if (type == 'sc') {
      description = "do Scope map";
    } else if (type == 'dd') {
      description = "do Deep dive ";
    } else if (type == 'de') {
      description = 'do Design for ' + attribute;
    } else if (type == 'ex') {
      description = 'do Test for ' + attribute;
    } else if (type == 'bex') {
      description = 'do reTest for ' + attribute;
    }
    return description;
  }
  //checks the current value of the check box for interactions drop down
  //if true -> adds to the interaction model
  //if false -> removes from the interaction model
  mapEutToEut(eut: any, isChecked: any) {
    isChecked
      ? this.addEUT(eut, this.selectedEntity)
      : this.deleteEUT(eut, this.selectedEntity);
    this.getMaps();
    this.constructMapping();
  }
  addEUT(eID: any, Primaryeut: any) {
    // console.log(eID, eut);
    this.modelData.interactionMap.push({ eut2: eID, eut1: Primaryeut.eID });
    this.syncModelDataObject = {
      "type": "IMAP",
      "operation": "CREATE",
      "data": { eut1: Primaryeut.eID, eut2: eID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log('Imap', this.modelData.interactionMap);
    var eut = this.modelData.listOfEUTs.find((eut: any) => eut.eID == eID);
    if (eut) {
      var Task = this.modelData.tasks.find((eut: any) => (eut.entity_Id == eID));
      this.generateTaskObjInteract(Task, eut, Primaryeut.eID, 'ex');
    }
  }

  deleteEUT(eID: any, eut: any) {
    var index = this.modelData.interactionMap.findIndex(
      (map: any) => map.eut1 == eut.eID && map.eut2 == eID
    );
    if (index > -1) {
      this.modelData.interactionMap.splice(index, 1);
    }
    this.syncModelDataObject = {
      "type": "IMAP",
      "operation": "DELETE",
      "data": { eut1: eut.eID, eut2: eID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.deleteInteractTask(eID, eut.eID);
  }

  deleteInteractTask(eID: any, eutID: any) {
    // console.log("entity", eID);
    // console.log("primary", eutID);
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      if (this.modelData.tasks[i].entity_Id == eID && this.modelData.tasks[i].toolType == 'ex' && this.modelData.tasks[i].primaryentity_Id == eutID) {
        // console.log(this.modelData.tasks[i]);
        this.modelData.tasks.splice(i, 1);
        i--;
      }
    }
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "INTERACT",
      "data": { entity_Id: eID, primaryentity_Id: eutID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }
  generateTaskObjInteract(task: any, entity: any, primaryEUTId: any, toolType: any) {
    let taskObj: any = {};
    var attribute: any = {};
    if (entity.eType == "TF" || entity.eType == "XX") {
      attribute = {
        name: "Feature Behaviour",
        symbol: "Fe",
        level: "L4"
      };
    } else if (entity.eType == "UR") {
      attribute = {
        name: "Requirement Behaviour",
        symbol: "Rb",
        level: "L5"

      };
    } else if (entity.eType == "BF") {
      attribute = {
        name: "Flow Behaviour",
        symbol: "Fb",
        level: "L5"
      };
    }
    if (primaryEUTId) {
      var primaryentity_Task = this.modelData.tasks.find((eut: any) => (eut.entity_Id == primaryEUTId));
    }
    taskObj.task_combine_id = this.uuidv4();
    taskObj.assignedto = primaryentity_Task.assignedto;
    taskObj.assigneduser = primaryentity_Task.assigneduser;
    taskObj.attribute = attribute;
    taskObj.activity = { type: 'RI', name: 'Re-test', shortfrom: 'R-Test' };
    // taskObj.environment = this.model.choosenEntity.environment;
    taskObj.task_desc = 'do Retest ' + task.moduleName + ' | ' + entity.eName + ' for ' + attribute.name;
    taskObj.toolType = toolType;
    taskObj.moduleName = task.moduleName;
    taskObj.moduleID = task.moduleID;
    taskObj.entity_Id = entity.eID;
    taskObj.entity_desc = entity.eName;
    taskObj.entityType = entity.eType;
    taskObj.primaryentity_Id = primaryEUTId;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.status = 1;
    taskObj.taskId = this.uuidv4();
    // taskObj.impactedUnquieID = impactedUnquieID;
    taskObj.createdOn = new Date();
    // console.log("taskObj", taskObj);
    this.modelData.tasks.push(taskObj);
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "CREATE",
      "data": taskObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("this.modelData.tasks", this.modelData.tasks);
  }



  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  //contruct a string that contain the peronas mapped, attributes mapped and the interaction with other euts
  constructMapping() {
    // var this = this;
    this.mapText = '';
    if (this.persona.length > 0 && this.modelData.persona.length > 0) {
      //check if persona exits in list of persona
      // var ptype = this.model.persona.map(p => p.pType);
      // var found = this.persona.some(p => ptype.indexOf(p.pType) >= 0);
      var found = '';
      // if (found) {
      this.mapText += 'The list of personas are :\n';

      for (var i = 0; i < this.persona.length; i++) {
        if (i < this.persona.length - 1) {
          if (this.persona[i].pType) {
            // console.log("this.persona[i]", this.persona[i]);
            // console.log(this.modelData.persona);
            var personaName = this.modelData.persona.find(
              (p: any) => p.pType == this.persona[i].pType
            );
            // console.log("personaName", personaName);
            if (personaName) {
              this.mapText += personaName.pName + ',';
            }
          }

        } else {
          if (this.persona[i].pType) {
            var personaName = this.modelData.persona.find(
              (p: any) => p.pType == this.persona[i].pType
            );
            if (personaName) {
              this.mapText += personaName.pName + ',';
            }
          }
        }
      }
      this.mapText = this.mapText.slice(0, -1);
      this.mapText += '\n';
      this.mapText += '--------------------------------------\n';
    }
    // console.log("this.selectedEntity",this.selectedEntity);
    this.mappedAttributes = this.modelData.EUTdetails.find(
      (details: any) => details.eID == this.selectedEntity.eID
    );
    // console.log("mappedAttributes",this.mappedAttributes.testTypes);
    if (this.mappedAttributes.testTypes) {
      if (this.mappedAttributes.testTypes.length > 0) {
        this.mapText += 'To satisfy the list of attributes :\n';
        for (var j = 0; j < this.mappedAttributes.testTypes.length; j++) {
          var attName = this.config.listOfAttributesUpdated.find(
            (a: any) => a.symbol == this.mappedAttributes.testTypes[j].symbol
          );
          // console.log("attName", attName);
          if (attName) {
            // var desc = "";
            // console.log("attName", attName.symbol);
            // var testType = this.getAttributeDescription(attName.symbol);
            // console.log("testType", testType);
            // if (j < this.attribute.length - 1) {
            //   console.log("Attrdesc",testType);
            // var desc = "";
            // if (!attName) {
            //   this.mapText += attName.name + ': ' + desc + '\n';
            // } else {
            this.mapText += attName.name + ': ' + this.mappedAttributes.testTypes[j].desc + '\n';
            // }

            // } else {
            //   this.mapText += attName.name + ': ' + desc
            // }
          }
        }
        this.mapText += '\n';
        this.mapText += '--------------------------------------\n';
      }
    }
    if (this.interaction.length > 0) {
      this.mapText += 'Interacts with:\n';
      for (var i = 0; i < this.interaction.length; i++) {
        var eut1 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut1
        );
        var eut2 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut2
        );
        if (eut1 && eut2) {
          if (eut1.eType == 'TF') {
            if (eut1.eType == eut2.eType) {
              // if (i < this.interaction.length - 1) {
              var moduleName = this.getModuleName(eut2);
              this.mapText += moduleName + ' | ' + eut2.eName + ', ';
              // } else {
              //     this.mapText += eut2.eName;
              // }
            }
          }
        }
      }
      this.mapText = this.mapText.slice(0, -1);
      this.mapText += '\n';
      this.mapText += 'Used by:\n';
      for (var i = 0; i < this.interaction.length; i++) {
        var eut1 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut1
        );
        var eut2 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut2
        );
        if (eut1 && eut2) {
          if (eut1.eType != eut2.eType) {
            // if (i < this.interaction.length - 1) {
            var moduleName = this.getModuleName(eut2);
            this.mapText += moduleName + ' | ' + eut2.eName + ', ';
            // } else {
            //     this.mapText += eut2.eName;
            // }
          }
        }
      }
      this.mapText = this.mapText.slice(0, -1);
      this.mapText += '\n';
      this.mapText += '--------------------------------------\n';
    }
    this.syncModelDataObject = {
      "type": "SPECS",
      "operation": "MAPPING",
      "data": this.selectedEntityIDDetails
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }

  entitiesExists() {
    var entities = [];
    entities = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.mID == this.selectedModule.mID
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  // getEntityTypeName() {
  //   if (this.selectedModule == 'TF') {
  //     return 'features';
  //   } else if (this.selectedModule == 'UR') {
  //     return 'requirements';
  //   } else if (this.selectedModule == 'BF') {
  //     return 'flows';
  //   } else {
  //     return 'entities';
  //   }
  // }
  entityExists(eType: any) {
    var entityPresent = this.model.entityModel.entityExists(eType);
    return entityPresent;
  }
  entityPresent(eType: any) {
    var entityPresent = this.model.entityModel.entityPresent(
      eType,
      this.eutTypes[this.index]
    );
    return entityPresent;
  }

  getEntityType(eType: any) {
    var entityName = this.model.entityModel.getEntityType(eType);
    return entityName;
  }
  getVideoURL(urlName: any) {
    var videoURL = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  search(personaID: any) {
    // var persona = this.model.persona.find(map => map.pType == personaID);
    // return persona;
  }

  generateReport(auto: any) {
    let mapperArray = ['DeepDive'];
    window.localStorage.setItem('exportedData', JSON.stringify(mapperArray));
    window.localStorage.setItem(
      'scenarioEntity',
      JSON.stringify(['TF', 'UR', 'BF', 'XX'])
    );
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }
  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, (iframe) => {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'stopVideo',
        }),
        '*'
      );
    });
  }
  loadBugList() {
    // this.jiraBugsListComponent.loadData();
    window.open('/jirabugslist', '_blank');
  }

  generateMindMap() {
    this.mainComponent.sendJson(this.selectedEntityIDDetails);
  }
  // goToView();
}
